import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable, of} from 'rxjs';
import {catchError, flatMap, map, switchMap} from 'rxjs/operators';
import {actionEnterpriseFailure} from '../actions/enterprise.actions';
import {ToastrService} from "ngx-toastr";
import {FasterqServices} from "../../containers/fasterq/services/fasterq-services";
import {IAppSettingsWrap} from "../../interfaces";
import {actionLoadOrdersFailure} from "../actions/user.actions";
import {UserService} from "../../services";
import {
    actionFasterqAddedLine,
    actionFasterqAddLine,
    actionFasterqConfig,
    actionFasterqGetLines,
    actionFasterqLinesSuccess,
    actionFasterqLoadAnalytics,
    actionFasterqLoadedAnalytics,
    actionFasterqLoadedLine,
    actionFasterqLoadedQueues,
    actionFasterqLoadTerminalLine,
    actionFasterqLoadQueues,
    actionFasterqQueueCalledSave,
    actionFasterqQueueCalledSaved,
    actionFasterqQueueServiceSave,
    actionFasterqQueueServiceSaved,
    actionFasterqRemovedLine,
    actionFasterqRemoveLine,
    actionFasterqResetedLine,
    actionFasterqResetLine,
    actionFasterqUpdatedLine,
    actionFasterqUpdateLine, actionFasterqLoadedTerminalLine
} from "../actions/fasterq.actions";
import {IFasterqAction, IFasterqPayload, IUiStateFasterq} from "../../interfaces/fasterq-interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../services";
import {Compbaser} from "../../components/compbaser";
import {FasterqLineModel} from "../../models/fasterq-line-model";

@Injectable()
export class FasterqEffects extends Compbaser {

    loadFasterqLines$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqLoadTerminalLine),
            // map((action  => action),
            switchMap((v) =>
                this.fasterqService.serverPutCommand(v, 'GetLinePut').pipe(
                    map((reply) => {
                        const data: any = reply.payload.serverReplay[0];
                        const line = new FasterqLineModel(data);
                        return actionFasterqLoadedTerminalLine({line});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadFasterqQueCallSave$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqQueueCalledSave),
            switchMap((v) => {
                    this.fasterQueueInFlight = true;
                    const options: IFasterqPayload = Object.assign({}, v.payload.queueSave.queue.getData().toJS(), v.payload.queueSave) as unknown as IFasterqPayload;
                    return this.fasterqService.serverPutCommand({payload: options}, `Queue/${v.payload.queueSave.queue_id}`).pipe(
                        map((i_payload) => {
                            this.fasterQueueInFlight = false;
                            i_payload.payload.queueSave = v.payload.queueSave;
                            return actionFasterqQueueCalledSaved(i_payload);
                        }),
                        catchError((i_error) => {
                            this.fasterQueueInFlight = false;
                            console.log(`actionLoadOrdersFailure ${i_error.message}`);
                            return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                        })
                    );
                }
            )
        )
    );

    loadFasterqServiceCallSave$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqQueueServiceSave),
            switchMap((v) => {
                    this.fasterQueueInFlight = true;
                    const options = Object.assign({}, v.payload.queueSave.queue.getData().toJS(), v.payload.queueSave) as unknown as IFasterqPayload;
                    return this.fasterqService.serverPutCommand({payload: options}, `Queue/${v.payload.queueSave.queue_id}`).pipe(
                        map((i_payload) => {
                            this.fasterQueueInFlight = false;
                            i_payload.payload.queueSave = v.payload.queueSave;
                            return actionFasterqQueueServiceSaved(i_payload);
                        }),
                        catchError((i_error) => {
                            this.fasterQueueInFlight = false;
                            console.log(`actionLoadOrdersFailure ${i_error.message}`);
                            return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                        })
                    );
                }
            )
        )
    );

    loadFasterqQueues$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqLoadQueues),
            switchMap((v) =>
                this.fasterqService.serverPostCommand(v, 'Queues', true).pipe(
                    map((i_payload) => {
                        return actionFasterqLoadedQueues(i_payload);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadFasterqAnalytics$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqLoadAnalytics),
            switchMap((v) =>
                //     var options: RequestOptionsArgs = this.createServerCall('/', RequestMethod.Post, action.payload)
                this.fasterqService.serverPostCommand(v, 'LineAnalytics', true).pipe(
                    map((i_payload) => {
                        return actionFasterqLoadedAnalytics(i_payload);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    pollServicing$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqLoadQueues),
            switchMap((v) =>
                this.fasterqService.serverPostCommand(v, 'LastCalledQueue', true).pipe(
                    map((i_result) => {
                        const uiState: IUiStateFasterq = {
                            fasterqNowServicing: String(i_result)
                        };
                        this.storeSelector.dispatch(actionFasterqConfig(i_result.payload.serverReplay.service_id));
                        // var uiState: IUiState = {fasterq: {fasterqNowServicing: data}};
                        // this.yp.dispatch(({type: ACTION_UISTATE_UPDATE, payload: uiState}));
                        return actionFasterqLoadedQueues(i_result);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    addFasterqLine$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqAddLine),
            switchMap((v: IFasterqAction) =>
                this.fasterqService.serverPostCommand(v, 'Line', true).pipe(
                    map((i_reply) => {
                        // return actionFasterqAddedLine({payload: {serverReplay: i_reply, data: v.payload}});
                        return actionFasterqAddedLine(i_reply);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    resetFasterqLine$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqResetLine),
            switchMap((v: IFasterqAction) =>
                this.fasterqService.serverPostCommand(v, 'ResetQueueCounter', true).pipe(
                    map((i_reply) => {
                        this.toastr.info(this.translocoService.translate('toast.lineReset', {}, this.translocoService.getActiveLang()) + ' ' + v.payload.line_id);
                        return actionFasterqResetedLine(i_reply);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );


    updateFasterqLine$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqUpdateLine),
            switchMap((v: IFasterqAction) =>
                this.fasterqService.serverPutCommand(v, `Line/${v.payload.line_id}`).pipe(
                    map((i_reply) => {
                        i_reply.payload.data = v.payload;
                        return actionFasterqUpdatedLine(i_reply);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    removeFasterqLine$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqRemoveLine),
            flatMap((v: IFasterqAction) =>
                this.fasterqService.removeLine(v).pipe(
                    map((i_reply) => {
                        i_reply.payload.line_id = v.payload.line_id;
                        return actionFasterqRemovedLine(i_reply);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadFasterqLine$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFasterqGetLines),
            // map((action  => action),
            switchMap((v) =>
                this.fasterqService.serverGetCommand('Lines', true).pipe(
                    map((i_payload) => {
                        return actionFasterqLinesSuccess(i_payload);
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    private coreAppData: IAppSettingsWrap;
    private fasterQueueInFlight: boolean;

    constructor(private fasterqService: FasterqServices,
                private userService: UserService,
                private translocoService: TranslocoService,
                private actions$: Actions,
                private toastr: ToastrService,
                private storeSelector: StoreSelectorsService) {
        super();
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
    }

    problemSavingAlert(msg, error, ofObs: boolean): Observable<any> | any {
        this.toastr.error(msg);
        console.log('problem remote server ' + error);
        if (ofObs) {
            return of(actionEnterpriseFailure({errorMessage: msg, enterprise: []}));
        } else {
            return actionEnterpriseFailure({errorMessage: msg, enterprise: []});
        }
    }
}

